var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogVisible,
        width: _vm.width,
        fullscreen: _vm.fullscreen,
        top: _vm.top,
        modal: _vm.modal,
        "modal-append-to-body": _vm.modalAppendToBody,
        "append-to-body": _vm.appendToBody,
        "lock-scroll": _vm.lockScroll,
        "custom-class": _vm.customClass,
        "close-on-click-modal": _vm.closeOnClickModal,
        "show-close": _vm.showClose,
        "before-close": _vm.handleBeforeClose,
        center: _vm.center,
        "destroy-on-close": _vm.destroyOnClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleCloes,
      },
    },
    [
      _vm._t("default"),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [_vm._t("footer")],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }